import React from 'react';
import "./ui.css";

const PageHeader = ({title, text}) => {
  return (
    <div className='page-header'>
        <h2>{title}</h2>
        <p>{text}</p>
    </div>
  )
}

export default PageHeader